import React, { useState, useEffect, useMemo } from "react";
import { Table, Button, Input, Icon, Row, Pagination, Col } from "antd";

import { getUsers } from "../actions/index";
import UserForm from "./form";
import { ClearFilterButton } from "../../../components/ListButtons/clearFilter";

export function UserTable({ type }) {
    const [loadingData, setLoadingData] = useState(false);
    const [dataSource, setDataSource] = useState([]);
    const [filter, setfilter] = useState({});
    const [pagination, setPagination] = useState({
        page: 1,
        perPage: 10,
    });
    const [metadata, setMetadata] = useState([]);
    const [modalData, setModalData] = useState({ isVisible: false });

    // Get form from API
    useEffect(() => {
        setLoadingData(true);

        const values = {
            ...filter,
            pagina: pagination.page,
            resultados_pagina: pagination.perPage,
            tab: type,
        };
        getUsers(values).then((response) => {
            setDataSource(response.lista);
            setMetadata(response.metadata);
            setLoadingData(false);
        });
    }, [pagination, filter, type]);

    //---------------------------- filter --------------------------------

    const getColumnSearchProps = (key) => {
        const searchInput = React.createRef();
        const filteredValue = filter[`filtro_${key}`];
        return {
            filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
                <div style={{ padding: 8 }}>
                    <Input
                        ref={searchInput}
                        placeholder={`Pesquisar`}
                        value={selectedKeys[0]}
                        onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
                        onPressEnter={() => handleSearch(selectedKeys, confirm)}
                        style={{
                            width: 188,
                            marginBottom: 8,
                            display: "block",
                        }}
                    />
                    <Button
                        type="primary"
                        onClick={() => handleSearch(selectedKeys, confirm)}
                        icon="search"
                        size="small"
                        style={{ width: 90, marginRight: 8 }}
                    >
                        Pesquisar
                    </Button>
                    <Button onClick={() => handleReset(clearFilters)} size="small" style={{ width: 90 }}>
                        limpar
                    </Button>
                </div>
            ),
            filterIcon: (filtered) => <Icon type="search" style={{ color: filtered ? "#1890ff" : undefined }} />,
            filteredValue: filteredValue ? [filteredValue] : [],
            onFilterDropdownVisibleChange: (visibleDropdown) => {
                if (visibleDropdown) {
                    setTimeout(() => searchInput?.current?.focus(), 100);
                }
            },
        };
    };

    const getColumnSortProps = (dataIndex) => {
        const sortInFilter = filter[`ordenacao_${dataIndex}`];
        const columnSort = sortInFilter === "ASC" ? "ascend" : sortInFilter === "DESC" ? "descend" : null;
        return {
            sorter: true,
            sortOrder: columnSort,
        };
    };

    const handleSearch = (_, confirm) => {
        confirm();
    };

    const handleReset = (clearFilters) => {
        clearFilters();
    };

    const handleTableChange = (_pagination, filters, sorter) => {
        const obj = {};
        if (filters) {
            Object.entries(filters).forEach(([key, val]) => {
                if (val[0]) obj["filtro_" + key] = val[0];
            });
        }
        if (sorter.columnKey && sorter.order) {
            const value = sorter.order === "ascend" ? "ASC" : "DESC";
            obj["ordenacao_" + sorter.columnKey] = value;
        }

        setPagination({
            ...pagination,
            page: 1,
        });
        setfilter(obj);
    };
    //---------------------------- endfilter -----------------------------
    const pageChange = (page, perPage) => {
        setPagination({
            page,
            perPage,
        });
    };

    const hideModal = () => {
        setModalData({
            isVisible: false,
        });
    };
    const handleEdit = (record) => {
        setModalData({
            isVisible: true,
            ...record,
        });
    };

    function clearFilters() {
        setPagination((state) => ({
            ...state,
            page: 1,
        }));

        setfilter({});
    }

    const columns = [
        {
            title: "Nome",
            dataIndex: "nome",
            key: "nome",
            ...getColumnSearchProps("nome"),
            ...getColumnSortProps("nome"),
        },
        {
            title: "Utilizador",
            dataIndex: "username",
            key: "username",
            ...getColumnSearchProps("username"),
            ...getColumnSortProps("username"),
        },
    ];

    if (type === "all") {
        columns.push({
            title: "Categoria",
            dataIndex: "categoria",
            key: "categoria",
            ...getColumnSearchProps("categoria"),
            ...getColumnSortProps("categoria"),
        });
    }

    columns.push(
        {
            title: "Tipo utilizador",
            dataIndex: "tipo",
            key: "tipo",
            ...getColumnSearchProps("tipo"),
            ...getColumnSortProps("tipo"),
        },
        {
            title: "E-mail",
            dataIndex: "email",
            key: "email",
            ...getColumnSearchProps("email"),
            ...getColumnSortProps("email"),
        },
        {
            title: "Telefone",
            dataIndex: "telefone",
            key: "telefone",
            ...getColumnSearchProps("telefone"),
            ...getColumnSortProps("telefone"),
        },
        {
            title: "Ação",
            key: "action",
            render: (_, record) => (
                <Button
                    type="link"
                    style={{
                        padding: 0,
                    }}
                    onClick={() => handleEdit(record)}
                >
                    Editar
                </Button>
            ),
        }
    );

    const showClearFilterButton = useMemo(() => {
        if (Object.keys(filter).length !== 0) {
            return true;
        }

        return false;
    }, [filter]);

    return (
        <>
            <Row gutter={[16, 16]} type="flex" justify="end">
                <Col xs={24}>{showClearFilterButton && <ClearFilterButton onClick={clearFilters} />}</Col>

                <Col span={24}>
                    <Table
                        size="middle"
                        rowKey={(data) => data.username + "-table"}
                        columns={columns}
                        pagination={false}
                        dataSource={dataSource}
                        loading={loadingData}
                        onChange={handleTableChange}
                    />
                </Col>
            </Row>
            <Row>
                <Pagination
                    style={{ float: "right", marginTop: 16 }}
                    current={metadata.pagina}
                    defaultPageSize={metadata.resultados_pagina}
                    size="small"
                    total={metadata.resultados}
                    showSizeChanger
                    showTotal={(total) => `Total registos: ${total}`}
                    onShowSizeChange={pageChange}
                    onChange={pageChange}
                />
            </Row>
            {modalData.isVisible && <UserForm modalData={modalData} hideModal={hideModal} />}
        </>
    );
}
